import reportException from '../../shared/lib/report-exception';

export const readCookie = ({
  name,
}) => {
  try {
    let i;
    let x;
    let y;
    const arRcookies = document.cookie.split(';');
    for (i = 0; i < arRcookies.length; i++) {
      x = arRcookies[i].substr(0, arRcookies[i].indexOf('='));
      y = arRcookies[i].substr(arRcookies[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === name) {
        return unescape(y);
      }
    }
  } catch (err) {
    reportException(err, {}, 'read-cookie');
  }
};



// WEBPACK FOOTER //
// ./src/utils/readCookie.js